import Header from 'components/Navigation/Header'
import Sidebar from 'components/Navigation/Sidebar'
import BottomNav from 'components/Navigation/BottomNav'
import Head from 'next/head'
import { useEffect, useState } from 'react'
import { 
  ContextProvider, 
  Holding, 
  SectorDiversification,
  AssetClassDiversification,
  SizeStyleDiversification
} from 'components/StateProvider'
import styled from 'styled-components'

import '@trendmicro/react-buttons/dist/react-buttons.css';
import '@trendmicro/react-dropdown/dist/react-dropdown.css';
import '../styles/index.css'

import { useRouter } from 'next/router'
import Loading from '@components/Util/Loading'

import { fetchFromSheet, fetchFromSheet2D } from '../sheet.best/sheet-utils'

const Application = ({ Component, pageProps }) => {
  const router = useRouter()
  const { events } = router

  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const start = () => setLoading(true)
    const end = () => setLoading(false)

    events.on('routeChangeStart', start)
    events.on('routeChangeComplete', end)
    events.on('routeChangeError', end)
    return () => {
      events.off('routeChangeStart', start)
      events.off('routeChangeComplete', end)
      events.off('routeChangeError', end)
    }
  }, [])

  const [portfolio, setPortfolio] = useState([] as Holding[])
  const [sectorDiversification, setSectorDiversification] = useState({} as SectorDiversification)
  const [assetClassDiversification, setAssetClassDiversification] = useState({} as AssetClassDiversification)
  const [sizeStyleDiversification, setSizeStyleDiversification] = useState({} as SizeStyleDiversification)

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchFromSheet({
          url: `https://sheet.best/api/sheets/359db887-fbe2-435e-b2fa-82c6e48093be`,
          headerRow: 6,
          startingDataRow: 7,
          filterFunction: data => data.filter(data => (data as any).Symbol)
        })
        setPortfolio(data as Holding[])
      }
      catch(e) {
        console.error(e)
      }

      try {
        const data = await fetchFromSheet2D({
          url: `https://sheet.best/api/sheets/359db887-fbe2-435e-b2fa-82c6e48093be/tabs/Sector Diversification`,
          key: 'Sector',
          filterFunction: data => data.filter(data => !data.Sector.includes('*'))
        })

        setSectorDiversification(data as SectorDiversification)
      }
      catch(e) {
        console.error(e)
      }

      // try {
      //   const data = await fetchFromSheet2D({
      //     url: `https://sheet.best/api/sheets/359db887-fbe2-435e-b2fa-82c6e48093be/tabs/Asset Class Diversification`,
      //     key: 'Instrument',
      //     filterFunction: data => data.filter(data => !data.Instrument.includes('*'))
      //   })

      //   setAssetClassDiversification(data as AssetClassDiversification)
      // }
      // catch(e) {
      //   console.error(e)
      // }

      // try {
      //   const data = await fetchFromSheet2D({
      //     url: `https://sheet.best/api/sheets/359db887-fbe2-435e-b2fa-82c6e48093be/tabs/Size-Style Diversification`,
      //     key: 'Size/Style',
      //     filterFunction: data => data.filter(data => !data['Size/Style'].includes('*'))
      //   })

      //   setSizeStyleDiversification(data as SizeStyleDiversification)
      // }
      // catch(e) {
      //   console.error(e)
      // }
    })()
  }, [])

  return (
    <ContextProvider value={{
      portfolio,
      sectorDiversification,
      assetClassDiversification,
      sizeStyleDiversification
    }}>
      <Header />

      <Head>
        <meta property="og:url" content="https://simm.netlify.app" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content="Monitor the SIMM equity fund to enhance decision making through insightful portfolio analytics. View interactive charts, transactions, and the Western New York Index."
        />
        <meta property="og:image" content={'/social-share.png'} />

        <meta name="twitter:title" content="Portfolio - SIMM" />
        <meta name="twitter:description" content="Monitor the SIMM equity fund to enhance decision making through insightful portfolio analytics. View interactive charts, transactions, and the Western New York Index." />
        <meta name="twitter:image" content="/social-share.png" />
        <meta name="twitter:card" content="summary_large_image"></meta>
        <meta name="twitter:site" content="@bonasimm"></meta>
      </Head>

      <S_AppContainer>
        <S_Sidebar>
          <Sidebar />
        </S_Sidebar>

        <S_App>
          {
            loading
              ? <S_Center>
                  <Loading />
                </S_Center>
              : <Component {...pageProps} />
          }
        </S_App>
      </S_AppContainer>

      <BottomNav />
      <S_VSpacer />
    </ContextProvider>
  )
}

export default Application

const S_Center = styled.div`
  width: 100%;
  height: calc(100vh - 120px);
  display: flex;
  justify-content: center;
  align-items: center;
`

const S_AppContainer = styled.div`
  width: 100%;
  display: flex;
`

const S_Sidebar = styled.div`
  width: var(--Sidebar_Width);
  display: flex;
  height: 100vh;
`

const S_App = styled.div`
  width: calc(100% - var(--Sidebar_Width));
  max-width: calc(100% - var(--Sidebar_Width));
  display: flex;
  height: auto;
  overflow: auto;
`

const S_VSpacer = styled.div`
  width: 100%;
  height: 40px;
`